import { motion } from "framer-motion";
import { Mail, Shield, Clock, MessageSquare } from "lucide-react";
import SellContactForm from "@/components/sell/SellContactForm";

const SellContact = () => {
  return (
    <section id="contact" className="py-24 scroll-mt-20">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-10"
          >
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
              <Mail className="w-4 h-4" />
              Réponse sous 24h
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Prêt à vous démarquer ?
            </h2>
            <p className="text-muted-foreground text-sm sm:text-lg mb-6">
              Décrivez votre projet et recevez votre portfolio personnalisé
            </p>
            
            {/* Trust indicators */}
            <div className="flex flex-wrap justify-center gap-6 mb-8">
              {[
                { icon: Clock, text: "Réponse < 24h" },
                { icon: Shield, text: "14j satisfait ou remboursé" },
                { icon: MessageSquare, text: "Échange gratuit" },
              ].map(({ icon: Icon, text }) => (
                <span key={text} className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon className="w-3.5 h-3.5 text-primary" />
                  {text}
                </span>
              ))}
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="p-8 rounded-2xl bg-card/60 backdrop-blur-sm border border-border/50 shadow-xl shadow-primary/5"
          >
            <SellContactForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SellContact;
